import { gql } from '@apollo/client';

export default gql`
  query getPendingApprovals($approvalRole: String, $opType: Int) {
    getPendingApprovals(approvalRole: $approvalRole, opType: $opType) {
      ok
      message
      count
      data {
        _id
        docNo
        title
        desc
        time
        amount
        total
        approvalStatus
        approvalHistory
        customerName
        customerNameAr
        employeeName
        employeeNameAr
        supplierName
        supplierNameAr
        contractName
        contractNameAr
        opType
        createdAt
        __typename
      }
    }
  }
`;
